// CPC LOCAL: network card fed by Push Hub + RPC (replaces suix_getNetworkMetrics).

import { CoinFormat, formatBalance } from '@mysten/core';
import { useSuiClientQuery } from '@mysten/dapp-kit';
import { Heading, Text } from '@mysten/ui';

import { FormattedStatsAmount, StatsWrapper } from '~/components/HomeMetrics/FormattedStatsAmount';
import { useCpcHomeStats } from '~/hooks/useCpcHomeStats';
import { Card } from '~/ui/Card';
import { Divider } from '~/ui/Divider';

export function CpcNetworkActivity() {
	const stats = useCpcHomeStats();
	const { data: referenceGasPrice } = useSuiClientQuery('getReferenceGasPrice');
	const gasPriceFormatted =
		typeof referenceGasPrice === 'bigint'
			? formatBalance(referenceGasPrice, 0, CoinFormat.FULL)
			: null;

	return (
		<Card bg="dark" spacing="lg" height="full">
			<div className="flex flex-col gap-4">
				<div className="flex flex-col gap-1">
					<Heading variant="heading4/semibold" color="dark">
						Network Activity
					</Heading>
					<Text variant="subtitleSmall/medium" color="steel">
						Chain RPC + Push Hub CLOB
					</Text>
				</div>
				<div className="flex flex-wrap gap-6">
					<FormattedStatsAmount
						label="Trades (5m)"
						tooltip="CLOB trades indexed by Push Hub in the last 5 minutes"
						amount={stats.trades5m}
						size="md"
						color="dark"
					/>
					<FormattedStatsAmount
						label="Trades (24h)"
						tooltip="CLOB trades in the last 24 hours"
						amount={stats.trades24h}
						size="md"
						color="dark"
					/>
				</div>
				<Divider color="dark" />

				<StatsWrapper
					orientation="horizontal"
					label="Reference Gas Price"
					tooltip="Current epoch reference gas price from fullnode RPC"
					postfix={gasPriceFormatted !== null ? 'MIST' : null}
					size="sm"
					color="dark"
				>
					{gasPriceFormatted}
				</StatsWrapper>

				<Divider color="dark" />

				<div className="flex flex-1 flex-col gap-2">
					<FormattedStatsAmount
						orientation="horizontal"
						label="Checkpoint"
						tooltip="Latest checkpoint synced by Push Hub / fullnode"
						amount={stats.checkpointSeq}
						size="sm"
						color="dark"
					/>
					<FormattedStatsAmount
						orientation="horizontal"
						label="CLOB Events"
						tooltip="Order book events collected by Event Receiver"
						amount={stats.chainEvents}
						size="sm"
						color="dark"
					/>
				</div>
			</div>
		</Card>
	);
}
